export const ERROR_MESSAGE: string = 'ERROR';
export const OK_MESSAGE: string = 'OK_MESSAGE';